import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

interface Props {
  scrollProgress: number
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollProgress',
  props: {
    scrollProgress: null
  },
  setup(__props: any) {

const props = __props as {
  scrollProgress: number
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "scroll-progress absolute right-0 top-0 opacity-70 sm:opacity-100 w-[2px] sm:w-1 bg-stone",
    style: _normalizeStyle({ height: props.scrollProgress * 100 + '%' })
  }, null, 4))
}
}

})